<template>
<div>
    <ul>
        <div id="submenu-title">
            <a id="submenu-link" @click="Inicio()" :class="selected == 'inicio' ? 'active-item' : ''">Inicio</a>
        </div>
        <!-- <div id="submenu-sub">
            <a v-show="active2" v-if="this.$session.get('isSuperAdmin') " 
            :class="selected == 'superAdminDashboard' ? 'active-item' : ''" @click="superAdminDashboard"> Cursos</a>
        </div> -->
        <div id="submenu-title">
            <a id="submenu-link" @click="showCourse" :class="selected == 'cursos' ? 'active-item' : ''">Cursos</a>
        </div>
        <div id="submenu-sub">
            <a v-show="active2" v-if="!this.$session.get('isSuperAdmin') && this.$session.get('isAdmin') == 'no'" 
            :class="selected == 'misCursos' ? 'active-item' : ''" @click="myCourses">Mis cursos</a>
        </div>
        <div id="submenu-sub">
            <a v-show="active2" v-if="!this.$session.get('isSuperAdmin') && this.$session.get('isAdmin') == 'no'" 
            :class="selected == 'certificados' ? 'active-item' : ''" @click="certificates">Certificados</a>
        </div>
        <div id="submenu-sub">
            <a v-show="active2" v-if="this.$session.get('isSuperAdmin') || this.$session.get('isAdmin') == 'yes'" @click="ranking">Ranking</a>
        </div> 
        <div id="submenu-sub">
            <a v-show="active2" v-if="!this.$session.get('isSuperAdmin') && this.$session.get('isAdmin') == 'no'" 
            :class="selected == 'planEstudio' ? 'active-item' : ''" @click="studyPlan">Plan de Estudio</a>
        </div>
        <div id="submenu-sub">
            <a v-show="active2" v-if="this.$session.get('isSuperAdmin')"
            :class="selected == 'crearCurso' ? 'active-item' : ''" @click="addCourse()">Crear Curso</a>
        </div>
        <div id="submenu-sub">
            <a v-show="active2" v-if="this.$session.get('isSuperAdmin')"
            :class="selected == 'administrarCursos' ? 'active-item' : ''" @click="adminCourses()">Administrar Cursos</a>
        </div>
        <div id="submenu-title">
            <a id="submenu-link" v-if="this.$session.get('isSuperAdmin') || this.$session.get('isAdmin') == 'yes'"
            :class="selected == 'administracion' ? 'active-item' : ''" @click="showAdmin" href="#">Administración</a>
        </div>
        <div id="submenu-sub">
            <a v-show="active3" v-if="this.$session.get('isSuperAdmin') || this.$session.get('isAdmin') == 'yes'" @click="users">Usuarios</a>
        </div>
        <div id="submenu-sub">
            <a v-show="active3" v-if="this.$session.get('isSuperAdmin') || this.$session.get('isAdmin') == 'yes'" @click="users">Empresa</a>
        </div>
        <div id="submenu-sub">
            <a v-show="active3" v-if="this.$session.get('isSuperAdmin') || this.$session.get('isAdmin') == 'yes'"
            :class="selected == 'matriz' ? 'active-item' : ''" @click="matriz">Matriz de Capacitación</a>
        </div>

    </ul>
</div>
</template>

<script>
import { userAPIRoot } from '@/config/redirect.config'
export default {
    data() {
        return {
            selected: '',
            active2: true,
            active3: true,
            
        }
    },
    mounted() {
        console.log('url', )
    },
    methods: {
        showCourse(){
            this.selected = 'cursos'
            this.active2 = !this.active2  
        },
        showAdmin(){
            this.selected = 'administracion'
            this.active3 = !this.active3
        },
        myCourses(){
            this.selected = 'misCursos'
            this.$router.push({ name: 'myCourses'})
        },
        superAdminDashboard(){
            this.selected = 'superAdminDashboard'
            this.$router.push({ name: 'superAdminDashboard'})
        },
        certificates(){
            this.selected = 'certificados'
            this.$router.push({ name: 'certificates'})
        },
        Inicio() {
            this.selected = 'inicio'
            // console.log(this.selected)
            if(this.$session.get('isSuperAdmin')){
                this.$router.push({ name: 'Dashboard'})
            }else if(this.$session.get('isAdmin') == 'yes'){

                this.$router.push({ name: 'adminDashboard'})
            }else {
                this.$router.push({ name: 'wellcome'})
            }
        },
        adminCourses() {
            this.selected = 'administrarCursos'
            this.$router.push({ name: 'AdminHome'})
        },
        addCourse() {
            this.selected = 'crearCurso'
            this.$router.push({ name: 'AddCourse'})
        },
        ranking() {
            this.selected = 'ranking'
            this.$router.push({ name: 'ranking'})
        },
        matriz() {
            this.selected = 'matriz'
            this.$router.push({ name: 'matriz'})
        },
        studyPlan() {
            this.selected = 'planEstudio'
            this.$router.push({ name: 'studyPlan'})
        },
        users(){
            location.href = userAPIRoot+'/login?token='+this.$cookie.get('token');
        }
    }
}
</script>

<style>
    #submenu-title{
        font-size: 26px;
        margin-top: 30px;
        color: #111;
        font-weight: 700;
    }

    #submenu-link{
        color: #365271
    }

    #submenu-link:hover{
        color: #3C90E0   
    }

    .active-item {
        color: #3C90E0 !important;
    }

    #submenu-sub {
        margin: 10px 0px 10px 25px;
        font-size: 18px;
    }

    #submenu-sub a{
        font-weight: 200;
        color: #111;
    }

    #title{
        font-size: 40px;
        margin: 0px 0px 0px;
    }

    .info-left{
        border-left: 3px solid #C3CFD9;
        padding-left: 20px;   
    }

    @media only screen and (max-width: 768px) {

        .btn-course{
           padding: 10px;
           margin-bottom: 10px;
        }
    
        .info-left{
            text-align: left;
        }
        .course-detail{
            margin-top: 20px;
            padding: 20px;
            background-color: white;
        }
        #title{
            font-size: 25px;
            margin: 55px 0px 0px;
        }

        #top-section{
            border-bottom: 3px solid #C3CFD9;
            padding-bottom: 20px;
            
        }

    }
    @media only screen and (max-width: 576px) {

        #submenu-item{
        font-size: 12px;
        padding: 5px 10px;
        font-weight: 400;
        }

        .btn-course{
           padding: 5px;
           margin-bottom: 10px;
        }

        span{
            font-size: 11px;
        }

        .info-left{
            text-align: left;
        }

        .course-detail{
            margin-top: 20px;
            padding: 10px 20px;
            background-color: white;
        }

        #title{
            font-size: 25px;
            margin: 10px 0px 0px;
        }

        #top-section{
            border-bottom: 3px solid #C3CFD9;
            padding-bottom: 20px;
            
        }

    }    
</style>



// WEBPACK FOOTER //
// src/components/submenu/submenu.vue